import React from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";
import useStyles from "./styles";
import { Link } from "react-router-dom";
import Typography from "@components/Typography";
import { __t } from "@core/translation/translation";
import clsx from "clsx";
import CustomLoader from "@components/CustomLoader";
import { formatDisplayDateTime } from "@core/helper/formatDisplayDateTime";

const NotificationsItem = ({ unReadNotifications, is_fetch, setAnchorEl }) => {
  const classes = useStyles();
  return is_fetch ? (
    unReadNotifications?.length > 0 ? (
      <List className={classes.listContainer}>
        {unReadNotifications?.map((item) => (
          <Link
            to={"/announcements/announcement"}
            onClick={() => setAnchorEl(null)}
          >
            <ListItem key={item.id} button className={classes.listItem}>
              <ListItemText
                primaryTypographyProps={{ variant: "subtitle2" }}
                primary={
                  item.text.length > 50
                    ? `${item.text.substring(0, 50)}...`
                    : item.text
                }
              />
              <ListItemText
                secondaryTypographyProps={{ variant: "caption" }}
                secondary={formatDisplayDateTime(item.created, { pattern: "YYYY/MM/DD - H:mm", input: "iso" })}
              />
            </ListItem>
          </Link>
        ))}
        <>
          {unReadNotifications?.length > 0 && (
            <Link to={"/announcements/announcement"}>
              <div
                className={classes.iconContainer}
                onClick={() => setAnchorEl(null)}
              >
                <Typography>{__t("Show All")}</Typography>
                <div className={clsx("icon-chevron-left", classes.icon)} />
              </div>
            </Link>
          )}
        </>
      </List>
    ) : (
      <div className={classes.EmptyContainer}>
        <img
          src="/static/icons/components-illustration-no-messages.svg"
          className={classes.image}
          alt="messages"
        />
        <div className={classes.EmptyText}>
          <Typography>
            {__t("There is no news or announcement to view.")}
          </Typography>
        </div>
      </div>
    )
  ) : (
    <div className={classes.loaderContainer}>
      <CustomLoader />
    </div>
  );
};

export default NotificationsItem;
